import React from 'react';

type IconComponentType = Function;
type IconLinkType = string;

type Props =
  | {
      IconComponent?: IconComponentType,
      iconLink: IconLinkType,
    }
  | {
      IconComponent: IconComponentType,
      iconLink?: IconLinkType,
    };

export const CustomIcon = ({ iconLink, IconComponent }: Props) => {
  if (iconLink) {
    return <img alt="" src={iconLink} width="28" height="28" />;
  }

  return IconComponent;
};
